export default function Loading() {
    return (
        <div className="Loading">
            Loading...
        </div>
    );
}